import React, {Component} from 'react';
import VideoContainer from "../../utils/VideoContainer";
import SoftwareVideoMedium from "./SoftwareVideoMedium";

class SoftwareVideoSmall extends Component {

    constructor(props) {

        super(props);

        this.state = {};

    }

    getItems() {

        if (this.props.videoList.length > 0) {
            return this.props.videoList.map(
                (v) => <VideoContainer key={'video-' + v.video_id}
                                       videoId={v.video_id}
                                       videoTitle={v.video_title}
                                       videoLength={v.video_length}
                                       videoDisabled={(v.video_disabled === 'true')}
                                       videoSource={this.props.source}
                                       classes={'col-lg-2'}
                                       onClick={this.props.onClick}
                />
            );
        }

        return 'No Videos found!';

    }

    render() {

        let items = this.getItems();

        return items;

    }

}

export default SoftwareVideoSmall;